import React from "react";
import { useNavigate } from "react-router-dom"; // ✅ Import
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch, useSelector } from "react-redux";
import loader from "../images/loader/loader1.jpg";
import { useMediaQuery } from 'react-responsive';
import { PiEngineFill } from "react-icons/pi";
import { FaCar } from "react-icons/fa";
import { FaRoad } from "react-icons/fa";
import { RiSteering2Fill } from "react-icons/ri";
import { GiGasPump } from "react-icons/gi";

function countWords(text) {
  return text.split(/\s+/).filter((word) => word !== "").length;
}

const ProductCard = (props) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const navigate = useNavigate();  

  const productState = useSelector((state) => state.product.product);
  const { grid, data } = props;
  const dispatch = useDispatch();
  const isTitleTooLong = productState?.some(
    (item) => countWords(item?.title) > 10
  );

  const currentItems = Array.isArray(data) ? data : [data];

const handleProductView = (product) => {
  if (product.availability === "Out of Stock") return;
  navigate(`/vehicle/${product.slug}`);
};

  return (
    <div className={`d-grid  flex-wrap ${grid === 12 ? "grid-cats" : ""}`}>
      {currentItems.map((item, index) => (
        <div key={index} className="product-wrapper-el-1">
          <div
            onClick={() => handleProductView(item)}
            className="product-card position-relative"
            style={{ width: grid === 12 ? "100%" : "244px" }}
          >
            <div className="product-image">
                {item?.availability === "Out of Stock" && (
                  <div className="sold-badge">
                    SOLD
                  </div>
                )}
              <LazyLoadImage
                alt={item?.title}
                title={item?.title}
                effect="blur"
                src={item?.images[0]?.url || loader}
                placeholderSrc={loader}
                width="100%"
                height={isDesktop ? 250 : "100%"}
                className="img-fluid mx-auto img-el"
              />
            </div>

            <div className="product-details">
              <h5 className="product-title ellipsis" >
                {item?.title}
              </h5>
            <div className="features">
              <span className="feature-item">
                <RiSteering2Fill className="feature-icon"/> 
                <span className="feature-text">{item?.transmission}</span>
              </span>

              <span className="feature-item">
                <PiEngineFill className="feature-icon"/> 
                <span className="feature-text">{item?.engineSize[0]?.title}</span>
              </span>

              <span className="feature-item">
                <FaCar className="feature-icon"/> 
                <span className="feature-text">{item?.yom}</span>
              </span>

              <span className="feature-item">
                <GiGasPump className="feature-icon"/> 
                <span className="feature-text">{item?.fuelType}</span>
              </span>
            </div>

                    <div className="price-wrapper">
                      <p className="nw-price">KES {item?.price.toLocaleString()}</p>
                     {item?.availability === "Out of Stock" ? (
                    <button className="sold-button" disabled>
                      <span>Sold</span>
                    </button>
                  ) : (
                    <button className="view-button">
                      <span>Details</span>
                    </button>
                  )}
                    </div>

             
            </div>
            <div className="action-bar position-absolute"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductCard;
